import {
  useProductContext,
  useRouterContext,
} from '../../../../context/PlpContext';

export const useProductCountData = () => {
  const router = useRouterContext();

  const { page = 1 } = router.query;

  const productContext = useProductContext();

  return {
    productContext,
    router: {
      page,
    },
  };
};
